import { render, staticRenderFns } from "./BatchBanner.vue?vue&type=template&id=1364b04a"
import script from "./BatchBanner.vue?vue&type=script&lang=js"
export * from "./BatchBanner.vue?vue&type=script&lang=js"
import style0 from "./BatchBanner.vue?vue&type=style&index=0&id=1364b04a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports